import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import { MIXPANEL_APP_NAME } from 'constants/mixpanel'
import { getResourceByKey } from 'domain/resources'
import * as Actions from 'store/actions/index.ts'
import {
  PRODUCT_CARD_BUTTON_ZONE,
  PRODUCT_CARD_GLOBAL_ZONE,
  PRODUCT_CARD_PICTURE_ZONE
} from 'constants/product'
import {
  getLabelsFormattedForTracking,
  getProductCallPrice,
  getProductPrice,
  getProductSourceKey,
  getProductTitle
} from 'domain/products'
import {
  getDaysSinceStartSale,
  getFiltersProducts,
  getIsHideReferencePriceFeatureEnabled,
  getIsProductsMapOpen,
  getNbFilteredProductsReferences,
  getNormalizedNbSubUniversesInCatalog,
  getNormalizedNbUniversesInCatalog,
  getOperationCode,
  getSaleStartTime,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

export const PRODUCT_CARD_ZONES = {
  [PRODUCT_CARD_BUTTON_ZONE]: 'CTA',
  [PRODUCT_CARD_GLOBAL_ZONE]: 'Other',
  [PRODUCT_CARD_PICTURE_ZONE]: 'Picture'
}

const mapStateToMPEvent = (eventName, state, action) => { // (eventName: string, state: State, action: ClickProductCard)
  const { productCardZone, productKey, productPosition, tabs, tags } = action.payload
  const product = getResourceByKey(state, productKey)
  const filteredProducts = getFiltersProducts(state)
  const stressMarketingOn = tags !== undefined && tags.length > 0
  const stressMarketingSlogan = (stressMarketingOn && tags !== undefined) ? tags.join(' ') : ''
  const productPrice = getProductPrice(filteredProducts, product)
  const shouldHideReferencePrice = getIsHideReferencePriceFeatureEnabled(state)

  return {
    '# of References': getNbFilteredProductsReferences(state),
    '# of Sub Universes': getNormalizedNbSubUniversesInCatalog(state),
    '# of Universes': getNormalizedNbUniversesInCatalog(state),
    'Click location': getIsProductsMapOpen(state) ? 'Map' : 'Catalogue page',
    'Click Position': PRODUCT_CARD_ZONES[productCardZone],
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Display advantage tab': tabs.Advantage,
    'Display details tab': tabs.Details,
    'Display map tab': tabs.Map,
    'Event Name': eventName,
    'Interaction Type': 'Click',
    ...getLabelsFormattedForTracking(product.ecomm.labels),
    'Lowest Price': getProductCallPrice(product),
    'Operation Code': getOperationCode(state),
    'Page Name': 'Catalogue Page',
    'Product': getProductTitle(product),
    'Product ID': getProductSourceKey(product),
    'Product Position': productPosition,
    'Product Price': productPrice?.price ?? null,
    'Ref price': !!productPrice?.msrp && !shouldHideReferencePrice,
    'Sale Start Time': getSaleStartTime(state),
    'Stock Status': product.outOfStock ? 'Not Available' : 'Available',
    'Stress Marketing ON': stressMarketingOn,
    'Stress Marketing slogan': stressMarketingSlogan,
    'Type': MIXPANEL_APP_NAME,
    'Under Universe': getSubUniverseName(state),
    'Unit': productPrice?.unit ?? null,
    'Universe': getUniverseName(state)
  }
}

const clickProductThumbnailEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.product.CLICK_PRODUCT_CARD),
  tap(action => {
    const eventName = 'Click Product Thumbnail'

    track(eventName, mapStateToMPEvent(eventName, state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickProductThumbnailEpic
